// deps
import React, { ReactElement, memo, useCallback, useContext, useMemo } from "react";

// styles
import { ToastContainer, IconContainer, TOAST_CONTAINER_CLASSNAME } from "./styles";

// dls
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { Toast } from "@swiggy-private/dls-web-recipe-food-web/dist/components/Toast";

// dls icons
import { CheckoutActionTypes, CheckoutContext } from "@swiggy-private/checkout-core";

// types
import { PaymentToastProps, TOAST_TYPE } from "@swiggy-private/payment-types";

// data test ids
import { GENERIC_PAYMENT_TOAST_CONTAINER } from "@swiggy-private/payment-test-ids";

function GenericPaymentToast(props: PaymentToastProps): ReactElement | null {
    const { setCheckoutState } = useContext(CheckoutContext);
    const _onDismiss = useCallback(() => {
        setCheckoutState({ type: CheckoutActionTypes.SHOW_PAYMENTS });
    }, [setCheckoutState]);

    const Icon = useMemo(() => {
        const getIcon = (): ReactElement => {
            switch (props?.type) {
                case TOAST_TYPE.ERROR:
                    return <SpriteIconWeb iconName="errorFilled24" strokeColor="negative" fillColor="negative" />;
                case TOAST_TYPE.INFO_FILLED:
                    return (
                        <SpriteIconWeb
                            iconName="infoFilled24"
                            strokeColor="text_Highest_Emphasis"
                            fillColor="warning"
                        />
                    );
                default:
                    return <SpriteIconWeb iconName="info24" />;
            }
        };

        return <IconContainer>{getIcon()}</IconContainer>;
    }, [props?.type]);
    return (
        <ToastContainer data-testid={GENERIC_PAYMENT_TOAST_CONTAINER}>
            <Toast
                message={props.message}
                leftAsset={Icon}
                containerClass={TOAST_CONTAINER_CLASSNAME}
                autoDismiss
                onDismiss={_onDismiss}
                show
            />
        </ToastContainer>
    );
}

export default memo(GenericPaymentToast);
